export const PRIZES = [
  {
    id: 0,
    type: "xp_gold",
    name: "EXPERIENCE POINTS",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/cad41840-76e5-4955-b94a-420914c3c500/original",
    boxes: ["harkan", "gamblor", "astr", "hh"],
    accent: "#FFD700",
  },
  {
    id: 1,
    type: "xp_purple",
    name: "EXPERIENCE POINTS",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/dbd09f8a-7756-4b22-2a12-56066fc47000/original",
    boxes: ["harkan", "gamblor", "astr", "hh"],
    accent: "#b36bff",
  },
  {
    id: 2,
    type: "xp_blue",
    name: "EXPERIENCE POINTS",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/c4251b95-3b07-472c-c0da-322fb206a000/original",
    boxes: ["harkan", "gamblor", "astr", "hh"],
    accent: "#7fb2ff",
  },
  {
    id: 3,
    type: "xp_black",
    name: "EXPERIENCE POINTS",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/8f9ca025-a245-420c-5e4e-47fd5d76ed00/original",
    boxes: ["harkan", "gamblor", "astr", "hh"],
    accent: "#4b4b4b",
  },
  {
    id: 4,
    type: "gamblor_bonus",
    name: "Gamblor Bonus",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/f428d037-a831-42f3-5589-a9f0d1247800/original",
    boxes: ["gamblor"],
    accent: "#FFD700",
  },
  {
    id: 5,
    type: "gamblor_spins",
    name: "Gamblor Spins",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/3ca8137b-2ca1-4a07-7877-6ce815dafd00/original",
    boxes: ["gamblor"],
    accent: "#FF4B6E",
  },
  {
    id: 6,
    type: "astr",
    name: "ASTR Tokens",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/30da259f-fc26-4d97-33da-716bac96b900/original",
    boxes: ["astr"],
    accent: "#AD00FF",
  },
  {
    id: 7,
    type: "astr_hh",
    name: "ASTR Jackpot",
    image:
      "https://imagedelivery.net/mOT2oLbg43au-DUXbkyY4w/30da259f-fc26-4d97-33da-716bac96b900/original",
    boxes: ["hh"],
    accent: "#AD00FF",
  },
];
